// extracted by mini-css-extract-plugin
export default {"root":"Input_root__ctNlD","auth":"Input_auth__8URg2","error":"Input_error__pF+1i","isIOS":"Input_isIOS__Fc0+Y"};